<!-- 代码已包含 CSS：使用 TailwindCSS , 安装 TailwindCSS 后方可看到布局样式效果 -->

<template>
  <div class="min-h-screen bg-gray-50 p-6">
    <!-- 顶部数据卡片区 -->
    <div class="grid grid-cols-4 gap-6 mb-6">
      <!-- 新增用户卡片 -->
      <div class="bg-white rounded-lg p-6 shadow-sm">
        <div class="flex items-center justify-between mb-4">
          <h3 class="text-gray-600 font-medium">新增用户</h3>
          <i class="fas fa-users text-blue-500"></i>
        </div>
        <div class="flex items-end justify-between">
          <div>
            <p class="text-3xl font-semibold text-gray-800">{{ userstas.today_new}}</p>
            <p class="text-sm text-gray-500 mt-1">今日新增</p>
          </div>
          <div class="text-right">
            <p class="text-xl font-medium text-gray-800">{{userstas.week_new}}</p>
            <p class="text-sm text-gray-500 mt-1">本周新增</p>
          </div>
        </div>
        <div class="mt-4 text-sm">
          <span class="text-green-500"><i class="fas fa-arrow-up"></i> {{userstas.growth_rate_user}}%</span>
          <span class="text-gray-500 ml-2">较上周</span>
        </div>
      </div>

      <!-- 新增商家卡片 -->
      <div class="bg-white rounded-lg p-6 shadow-sm">
        <div class="flex items-center justify-between mb-4">
          <h3 class="text-gray-600 font-medium">新增商家</h3>
          <i class="fas fa-store text-purple-500"></i>
        </div>
        <div class="flex items-end justify-between">
          <div>
            <p class="text-3xl font-semibold text-gray-800">{{userstas.today_new_merchants}}</p>
            <p class="text-sm text-gray-500 mt-1">今日新增</p>
          </div>
          <div class="text-right">
            <p class="text-xl font-medium text-gray-800">{{userstas.week_new_merchants}}</p>
            <p class="text-sm text-gray-500 mt-1">本周新增</p>
          </div>
        </div>
        <div class="mt-4 text-sm">
          <span class="text-green-500"><i class="fas fa-arrow-up"></i>{{userstas.growth_rate_merchants}}%</span>
          <span class="text-gray-500 ml-2">较上周</span>
        </div>
      </div>

      <!-- 平台信息卡片 -->
      <div class="bg-white rounded-lg p-6 shadow-sm">
        <div class="flex items-center justify-between mb-4">
          <h3 class="text-gray-600 font-medium">平台信息</h3>
          <i class="fas fa-chart-pie text-indigo-500"></i>
        </div>
        <div class="flex items-end justify-between">
          <div>
            <p class="text-3xl font-semibold text-gray-800">{{ userstas.total_users}}</p>
            <p class="text-sm text-gray-500 mt-1">总用户数</p>
          </div>
          <div class="text-right">
            <p class="text-xl font-medium text-gray-800">{{ userstas.total_merchants}}</p>
            <p class="text-sm text-gray-500 mt-1">总商家数</p>
          </div>
        </div>
        <div class="mt-4 text-sm">
          <span class="text-blue-500">活跃度 89%</span>
          <span class="text-gray-500 ml-2">本月</span>
        </div>
      </div>

      <!-- 货代订单卡片 -->
      <div class="bg-white rounded-lg p-6 shadow-sm">
        <div class="flex items-center justify-between mb-4">
          <h3 class="text-gray-600 font-medium">货代订单</h3>
          <i class="fas fa-shipping-fast text-orange-500"></i>
        </div>
        <div class="flex items-end justify-between">
          <div>
            <p class="text-3xl font-semibold text-gray-800">{{ userstas.todayNewOrder}}</p>
            <p class="text-sm text-gray-500 mt-1">今日新增</p>
          </div>
          <div class="text-right">
            <p class="text-xl font-medium text-gray-800">{{ userstas.pendingCount }}</p>
            <p class="text-sm text-gray-500 mt-1">待处理</p>
          </div>
        </div>
      </div>
    </div>

    <!-- 中部实时概况区 -->
    <div class="grid grid-cols-3 gap-6">
      <!-- 左侧图表区域 -->
      <div class="col-span-2 space-y-6">
        <!-- 用户增长趋势图 -->
        <div class="bg-white rounded-lg p-6 shadow-sm">
    <div class="flex items-center justify-between mb-6">
      <h3 class="text-gray-600 font-medium">用户增长趋势</h3>
      <div class="flex space-x-2">
        <button 
          v-for="day in [7, 30, 90]" 
          :key="day"
          @click="handleDaysChange(day)"
          :class="[
            'px-3 py-1 text-sm transition-colors',
            activeDays === day 
              ? 'text-white bg-blue-500' 
              : 'text-gray-600 bg-gray-100 hover:bg-gray-200'
          ]"
          class="!rounded-button whitespace-nowrap"
        >
          {{ day }} 天
        </button>
      </div>
    </div>
    <div ref="chart" class="w-full h-80"></div>
  </div>

        <!-- 汇率表格 -->
        <div class="bg-white rounded-lg p-6 shadow-sm">
          <div class="flex items-center justify-between mb-6">
            <h3 class="text-gray-600 font-medium">实时汇率</h3>
            <p class="text-sm text-gray-500">更新时间：2024-01-18 14:30</p>
          </div>
          <div class="grid grid-cols-3 gap-4">
            <div v-for="(rate, index) in exchangeRates" :key="index" class="p-4 bg-gray-50 rounded-lg">
              <div class="flex items-center justify-between">
                <span class="text-gray-600">{{ rate.currency }}</span>
                <span class="text-lg font-medium text-gray-800">{{ rateKey }}</span>
              </div>
              <div class="mt-2 text-sm" :class="rate.trend === 'up' ? 'text-green-500' : 'text-red-500'">
                <i :class="rate.trend === 'up' ? 'fas fa-arrow-up' : 'fas fa-arrow-down'"></i>
                {{ rate.change }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 右侧信息区 -->
      <div class="space-y-6">
        <!-- 拼柜费用 -->
        <div class="bg-white rounded-lg p-6 shadow-sm">
          <div class="flex items-center justify-between mb-4">
            <h3 class="text-gray-600 font-medium">当前拼柜费用</h3>
            <button class="text-blue-500 text-sm !rounded-button whitespace-nowrap">
              <i class="fas fa-sync-alt mr-1"></i>刷新
            </button>
          </div>
          <div class="space-y-4">
            <div class="flex items-center justify-between p-3 bg-gray-50 rounded">
              <span class="font-medium">￥{{Summary.fcl_price}}/立方</span>
            </div>
          </div>
        </div>

        <!-- 整柜费用 -->
        <div class="bg-white rounded-lg p-6 shadow-sm">
          <div class="flex items-center justify-between mb-4">
            <h3 class="text-gray-600 font-medium">当前整柜费用</h3>
            <button class="text-blue-500 text-sm !rounded-button whitespace-nowrap">
              <i class="fas fa-sync-alt mr-1"></i>刷新
            </button>
          </div>
          <div class="space-y-4">
            <div class="flex items-center justify-between p-3 bg-gray-50 rounded">
              <span class="font-medium">￥{{Summary.lcl_price}}/立方</span>
            </div>
          </div>
        </div>

        <!-- 系统通知 -->
        <div class="bg-white rounded-lg p-6 shadow-sm">
          <div class="flex items-center justify-between mb-4">
            <h3 class="text-gray-600 font-medium">系统通知</h3>
            <button class="text-blue-500 text-sm !rounded-button whitespace-nowrap">
              全部已读
            </button>
          </div>
          <div class="space-y-4">
            <div v-for="(notice, index) in systemNotices" :key="index" 
                 class="p-3 bg-gray-50 rounded flex items-start">
              <div :class="notice.read ? 'text-gray-400' : 'text-blue-500'" class="mt-1 mr-3">
                <i class="fas fa-circle text-xs"></i>
              </div>
              <div>
                <p class="text-gray-800 mb-1">{{ notice.content }}</p>
                <p class="text-sm text-gray-500">{{ notice.time }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import UserApi from '@/api/user.js';
import SettingApi from '@/api/setting.js';

export default {
  data() {
    return {
      exchangeRates: [
        { currency: 'USD/CNY', rate: '7.1862', trend: 'up', change: '0.05%' }
      ],
      systemNotices: [],
      userstas:{

      },
      Summary:{},
      activeDays: 7,
      chartData: {  
        xAxis: [],
        series: [],
        fullDates: []
      },
      activeDays: 7,
      chartInstance: null,
      loading: false,
      rateKey:0
    }
  
  },
  mounted() {
    this.getUserStats();
    this.getAccessKeyId();
    this.initChart();
    this.fetchData(this.activeDays);
    this.getSystemNotices();
    this.getSummary()
  },

  activated() {
    if (this.chart) {
      this.handleResize()
    }
  },

  methods: {
    getUserStats(){
      var self = this;
        UserApi.getUserStats({}, true)
          .then(data => {
           setTimeout(() => {
              self.userstas = data.data;
          })
    })
  },
  getAccessKeyId(){
    let self = this;
        SettingApi.exchangeRateDetail({}, true)
          .then(data => {
            let vars = data.data.vars.values;
            self.rateKey = vars.ss_ed;
          })
          .catch(error => {});
  },
  getSystemNotices(){
    var self = this;
        UserApi.getSystemNotices({}, true)
          .then(data => {
           setTimeout(() => {
              self.systemNotices = data.data.systemNotices;
          })
    })
  },
  initChart() {
      if (!this.$refs.chart) {
        console.error('图表容器未找到');
        return;
      }
      
      // 销毁旧实例（如果存在）
      if (this.chartInstance) {
        this.chartInstance.dispose();
      }
      
      try {
        this.chartInstance = echarts.init(this.$refs.chart);
        // 设置基础配置
        this.chartInstance.setOption({
          tooltip: { trigger: 'axis' },
          xAxis: { type: 'category' },
          yAxis: { type: 'value' },
          series: [{ type: 'bar' }]
        });
      } catch (error) {
        console.error('图表初始化失败:', error);
      }
    },

    // 获取数据

    async fetchData(days) {
    try {
      const res = await UserApi.growthTrend({ days: days });
      // 确保响应数据结构正确
      if (res.data) {
        this.chartData = {
          xAxis: res.data.xAxis || [],
          series: res.data.series || [],
          fullDates: res.data.fullDates || []
        };
        this.updateChart();
      } else {
        console.error('返回数据格式不正确:', res);
      }
    } catch (error) {
      console.error('数据获取失败:', error);
      // 可以设置默认数据或显示错误状态
      this.chartData = { xAxis: [], series: [], fullDates: [] };
    }
  },
  handleDaysChange(days) {
      if (this.activeDays === days) return // 如果点击的是当前已选天数则不处理
      this.activeDays = days
      this.fetchData(days)
    },

  updateChart() {
    if (!this.chartInstance) {
      console.warn('图表实例未初始化');
      return;
    }

    // 确保chartData存在且有xAxis属性
    if (!this.chartData || !this.chartData.xAxis) {
      console.warn('图表数据未准备好');
      return;
    }

    const option = {
      xAxis: { 
        type: 'category',
        data: this.chartData.xAxis 
      },
      yAxis: { type: 'value' },
      series: [{
        data: this.chartData.series,
        type: 'bar',
        itemStyle: { color: '#36a3f7' }
      }],
      tooltip: { trigger: 'axis' }
    };

    try {
      this.chartInstance.setOption(option, true); // 第二个参数true表示不合并旧配置
      window.addEventListener('resize', this.handleResize);
    } catch (error) {
      console.error('图表更新失败:', error);
    }
  },
    // 处理窗口resize
    handleResize() {
      if (this.chartInstance) {
        this.chartInstance.resize();
      }
    },
  getSummary(){
    var self = this;
        UserApi.getSummary({}, true)
          .then(data => {
           setTimeout(() => {
            self.Summary = data.data.vars.values
            console.log(self.Summary);
            
          })
    })
  },
  async fetchChartData() {
  try {
    const res = await UserApi.growthTrend({
          days:7
        })
    
    // 直接使用返回数据
    this.chartInstance.setOption({
      xAxis: { data: res.data.data.xAxis },
      series: [{ data: res.data.data.series }]
    });
    
  } catch (error) {
    console.error('获取数据失败:', error);
  }
}
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
    if (this.chartInstance) {
      this.chartInstance.dispose();
    }
  }
};
</script>

<style scoped>
.custom-shadow {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}
</style>




// WEBPACK FOOTER //
// src/views/home/home.vue